export default __webpack_public_path__ + "static/media/AcornMallCarpark_51.ac629699.png";